module.exports = __webpack_public_path__ + "img/upper_pocket _length.6015eb6d.png";